/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';
import type { Multipart } from './Multipart';
import {
    MultipartFromJSON,
    MultipartFromJSONTyped,
    MultipartToJSON,
    instanceOfMultipart,
} from './Multipart';
import type { SinglePart } from './SinglePart';
import {
    SinglePartFromJSON,
    SinglePartFromJSONTyped,
    SinglePartToJSON,
    instanceOfSinglePart,
} from './SinglePart';

/**
 * @type AssetUploadCompletionPayload
 * Exactly one of singlePart or multipart completion details.
 * @export
 */
export type AssetUploadCompletionPayload = SinglePart | Multipart;


/**
 * Check if a given object implements the AssetUploadCompletionPayload interface.
 */
export function instanceOfAssetUploadCompletionPayload(value: object): boolean {
    return instanceOfSinglePart(value) || instanceOfMultipart(value)
}

export function AssetUploadCompletionPayloadFromJSON(json: any): AssetUploadCompletionPayload {
    return AssetUploadCompletionPayloadFromJSONTyped(json, false);
}

export function AssetUploadCompletionPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetUploadCompletionPayload {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...SinglePartFromJSONTyped(json, true),
        ...MultipartFromJSONTyped(json, true),
    };
}

export function AssetUploadCompletionPayloadToJSON(value?: AssetUploadCompletionPayload | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...SinglePartToJSON(value as any),
        ...MultipartToJSON(value as any),
    };
}

